import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbaBarDashboard from '../SideNavaBarDashboard/SideNavbaBarDashboard';
import AdminHome from './AdminHome';
 import { IoCloseSharp } from "react-icons/io5";
 import { BsMenuButtonWideFill } from "react-icons/bs";
 
const AdminAddCategory = () => {
  const [categoryName, setCategoryName] = useState('');
  const [categoryCode, setCategoryCode] = useState('');
  const [categoryId, setCategoryId] = useState(null);
  const [message, setMessage] = useState('');

  // Fetch the next category ID when the component mounts or after saving
  const fetchNextCategoryId = async () => {
    try {
      const response = await axios.get('/api/next-category-id');
      setCategoryId(response.data.categoryId);
    } catch (error) {
      console.error('Error fetching next category ID:', error);
    }
  };

  useEffect(() => {
    fetchNextCategoryId();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Save the category
      const response = await axios.post('/api/add-category', {
        categoryName,
        categoryCode,
      });

      // Show success message
      setMessage('Category saved successfully!');

      // Clear the category name input field
      setCategoryName('');
      setCategoryCode('')

      // Fetch the next category ID immediately
      fetchNextCategoryId();
    } catch (error) {
      setMessage('Failed to save category');
      console.error(error);
    }
  };

  return (
    <>
<div className="tf-page-title">
            <div className="container-full">
                <div className="heading text-center">Add Category</div>
            </div>
        </div>
        <section className="flat-spacing-11">
            <div className="container">
                    <div className="row">
                      <AdminHome/>
    <div className="admin-category-form col-lg-9">
      {/* <h2></h2> */}
      <div className="category-details">
        <p><strong>Category ID:</strong> {categoryId}</p>
        <p><strong>Category Name:</strong></p>
        <input
          type="text"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          placeholder="Enter category name"
          required
          className="category-input"
        />
         <p><strong>Category Code:</strong></p>
        <input
          type="text"
          value={categoryCode}
          onChange={(e) => setCategoryCode(e.target.value)}
          placeholder="Enter category code"
          required
          className="category-input"
        />
      </div>
      <button onClick={handleSubmit} className="save-button">Save</button>
      {message && <p className="message">{message}</p>}
      
      <style jsx>{`
        .admin-category-form {
          font-family: Arial, sans-serif;
          max-width: 600px;
          margin: 20px auto;
          padding: 20px;
          background-color: #f9f9f9;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        
        h2 {
          text-align: center;
          margin-bottom: 20px;
          color: #333;
        }
        
        .category-details {
          margin-bottom: 20px;
        }
        
        .category-details p {
          font-size: 16px;
          margin-bottom: 8px;
          color: #555;
        }
        
        .category-input {
          width: 100%;
          padding: 10px;
          font-size: 16px;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-bottom: 20px;
          outline: none;
          transition: border-color 0.3s;
        }

        .category-input:focus {
          border-color: #007bff;
        }

        .save-button {
          width: 100%;
          padding: 12px;
          font-size: 16px;
          background-color: #28a745;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 0.3s;
        }

        .save-button:hover {
          background-color: #218838;
        }

        .message {
          text-align: center;
          font-size: 16px;
          color: #333;
        }
      `}</style>
    </div>
    </div>
    </div>
    {/* <div className="btn-sidebar-account">
                <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                    <i className="icon icon-sidebar-2"></i>
                </button>
            </div> */}

            <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                <div className="canvas-wrapper">
                    <header className="canvas-header">
                        <span className="title">SIDEBAR ACCOUNT</span>
                        
                        <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                    </header>
                  
                    <div className="canvas-body sidebar-mobile-append"> </div>
                </div>
            </div>
    </section>
    
    <div className="btn-sidebar-account">
                              <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                                  <BsMenuButtonWideFill />
                              </button>
                          </div>
              
                          <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                              <div className="canvas-wrapper">
                                  <header className="canvas-header">
                                      <span className="title">SIDEBAR ACCOUNT</span>
                                      {/* <SideNavbaBarDashboard /> */}
                                      <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                                  </header>
                                  
                                  <div className="canvas-body sidebar-mobile-append"> </div>
                              </div>
                          </div>
    
    </>
  );
};

export default AdminAddCategory;